import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext.tsx'
import { AuthProvider } from './contexts/AuthContext.tsx'
import AuthGuard from './components/AuthGuard.tsx'
import Layout from './components/Layout.tsx'
import Dashboard from './pages/Dashboard.tsx'
import Jobs from './pages/Jobs.tsx'
import CreateJob from './pages/CreateJob.tsx'
import JobDetails from './pages/JobDetails.tsx'
import Stores from './pages/Stores.tsx'
import Cities from './pages/Cities.tsx'
import Import from './pages/Import.tsx'
import Export from './pages/Export.tsx'
import CostManagement from './pages/CostManagement.tsx'
import Settings from './pages/Settings.tsx'
import Login from './pages/Login.tsx'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path='/login' element={<Login />} />
            <Route
              path='/*'
              element={
                <AuthGuard>
                  <Layout>
                    <Routes>
                      <Route path='/' element={<Dashboard />} />
                      <Route path='/jobs' element={<Jobs />} />
                      <Route path='/jobs/create' element={<CreateJob />} />
                      <Route path='/jobs/:id' element={<JobDetails />} />
                      <Route path='/stores' element={<Stores />} />
                      <Route path='/cities' element={<Cities />} />
                      <Route path='/import' element={<Import />} />
                      <Route path='/export' element={<Export />} />
                      <Route path='/costs' element={<CostManagement />} />
                      <Route path='/settings' element={<Settings />} />
                    </Routes>
                  </Layout>
                </AuthGuard>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
